import React from 'react';
import { connect } from 'react-redux';
import { addTransactionVoucherAction, selectCartTransactionVoucherResults } from '../../ducks/cart';
import { selectTransactionVouchers } from '../../ducks';
import { AppState } from '../../../../common/models/AppState';
import { TransactionVoucherResult } from '../../../../common/models/NewTransaction';
import { ModalSizes } from '../../../../common/constants/modal';
import { i18n } from '../../../../common/services/i18n';
import { Icon, Modal } from 'antd';
import { Button } from '../../../../common/components';

interface DispatchToProps {
    setTransactionVouchers: (payload: string[]) => void;
}

interface StateToProps {
    results: TransactionVoucherResult[];
    vouchers: string[];
}

type RemovedVoucherModalProps = {} & DispatchToProps & StateToProps;

const RemovedVoucherModal = ({ results, vouchers, setTransactionVouchers }: RemovedVoucherModalProps) => {

    const failedVouchers = results.filter(r => r.error || r.status === 'assigned');

    const handleConfirmClick = () => {
        setTransactionVouchers(vouchers.filter(v => !failedVouchers.some(r => r.publicKey === v)));
    };

    if (!failedVouchers.length) {
        return <></>;
    }

    return (
        <Modal
            visible={true}
            width={ModalSizes.default}
            footer={null}
            className="removed-voucher-modal"
        >
            <div className="removed-voucher-modal__content">
                <h3>{i18n.t('removedVoucherModal.title')}</h3>
                <Icon type="warning" className="removed-voucher-modal__icon" />
                <span className="removed-voucher-modal--warning">
                    {i18n.t('removedVoucherModal.content')}
                </span>
                <table>
                    {failedVouchers.map((result) => (
                        <tr>
                            <td>{result.publicKey}</td>
                            <td>{i18n.t(`informations.discountVoucher.modal.error.${result.error}`)}</td>
                        </tr>
                    ))}
                </table>
            </div>
            <div className="removed-voucher-modal__footer">
                <Button onClick={handleConfirmClick}>
                    {i18n.t('removedVoucherModal.confirm')}
                </Button>
            </div>
        </Modal>
    );
};

const mapDispatchToProps: DispatchToProps = {
    setTransactionVouchers: addTransactionVoucherAction,
};

const mapStateToProps = (state: AppState): StateToProps => ({
    results: selectCartTransactionVoucherResults(state),
    vouchers: selectTransactionVouchers(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemovedVoucherModal);
